import React, { useEffect, Fragment, useState } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { setProject, updateProject } from '../../../../redux/actions/projects';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DraggableModal from '../../../entities/EntityModals/DraggableModal';
import { RiskDecision } from '../../../../constants/Enums';
import { InputTemplate } from '../../../entities/EntityModals/InputTemplate';
import axiosMethods from '../../../../Axios/axios';
import { capitalizeStart } from '../../../helpers/genericHelper';

export const GoalModal = ({
  modal,
  toggle,
  type,
  riskDecision,
  controls,
  save,
  update,
  riskControl,
  updateIndex = null,
}) => {
  const [text, setText] = useState('');
  const [link, setLink] = useState(-1);
  const [riskDecisionType, setRiskDecisionType] = useState('');

  const decisionLower = String(riskDecision).toLowerCase();
  const isReducing = decisionLower === RiskDecision.reducing.toLowerCase();
  const requiresControl = decisionLower === RiskDecision.reducing.toLowerCase();

  const handleChangeText = (event) => {
    setText(event.target.value);
  };

  // Accept either native event or direct value (InputTemplate may pass value)
  const handleChangeLink = (eventOrValue) => {
    const value =
      eventOrValue && eventOrValue.target
        ? eventOrValue.target.value
        : eventOrValue;
    setLink(value);
  };

  const handletoggle = () => {
    setText('');
    setLink(-1);
  };

  // Validation states
  const hasText = Boolean(text?.trim());
  const hasValidControl = !requiresControl
    ? true
    : controls?.some((c) => String(c._id) === String(link));

  const canSave = hasText && hasValidControl;

  // Show warning whenever textarea is empty, and in reducing also when control is missing
  const showWarning = !hasText || (requiresControl && !hasValidControl);

  const handleSave = async () => {
    if (!canSave) return;

    if (updateIndex !== null) {
      const payload = {
        text: text,
        link: requiresControl ? link : -1,
        type: type,
      };
      update(payload);
    } else {
      const payload = {
        text: text,
        type: type,
        link: requiresControl ? link : -1,
      };
      save(payload);
    }
    handletoggle();
  };

  // Populate when editing; reset when opening for Add
  useEffect(() => {
    if (riskControl !== undefined && riskControl !== null) {
      setText(riskControl?.text ?? '');
      setLink(
        riskControl?.link !== undefined && riskControl?.link !== null
          ? riskControl.link
          : -1
      );
      setRiskDecisionType(type);
    } else if (modal && updateIndex === null) {
      setText('');
      setLink(-1);
      setRiskDecisionType(type);
    }
  }, [riskControl, type, modal, updateIndex]);

  return (
    modal && (
      <Fragment>
        <DraggableModal isOpen={modal} toggle={toggle}>
          <ModalHeader className="modal-header" toggle={toggle}>
            {riskControl ? `Edit ${type}` : `Add ${type}`}
          </ModalHeader>
          <div className="modal-line" style={{ zIndex: 1 }} />
          <ModalBody>
            <Form>
              <FormGroup>
                <Label htmlFor="text">{type}</Label>
                <Input
                  type="textarea"
                  name="text"
                  id="text"
                  placeholder={'Enter ' + type}
                  value={text}
                  onChange={handleChangeText}
                />
              </FormGroup>

              {isReducing && (
                <FormGroup>
                  <Label htmlFor="control">Control</Label>
                  <InputTemplate
                    type="select"
                    name="control"
                    onChange={handleChangeLink}
                    value={link}
                    selectDefault
                  >
                    <option value="-1">Select a control…</option>
                    {controls?.map((control) => (
                      <option key={control._id} value={control._id}>
                        {control.name}
                      </option>
                    ))}
                  </InputTemplate>
                </FormGroup>
              )}
            </Form>
          </ModalBody>
          <ModalFooter>
            {showWarning && (
              <small className="text-danger" style={{ fontSize: '0.85rem' }}>
                Warning: there are missing fields
              </small>
            )}
            <Button color="btn-add" onClick={handleSave} disabled={!canSave}>
              Save
            </Button>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </DraggableModal>
      </Fragment>
    )
  );
};
